import React, { Component } from "react";
import { createSelector } from "reselect";
import { connect } from "react-redux";
import moment from 'moment-timezone';
import MessangerProfile from "./MessangerProfile";
import MessageComposer from "./MessageComposer";
import { globalService as gs } from "../../../common/services";
import { animateScroll } from "react-scroll";
import Attachment from "./Attachment";

class Messenger extends Component {

	constructor(props) {
		super(props);
		this.state = {
			threads: [],
			loading: true,
			activeKey: props.activeKey,
			user_id: parseInt(gs.identity.user.user_id),
			//profile: gs.identity.user.userProfile,
			profile: props.profile,
			item: props.item,
		};
		this.initilizeState = this.state;
	}

	componentDidMount() {
		const { activeKey, user_id } = this.state;
		let query = gs.db.ref(`UserMessage/${activeKey}`);
		query.on("child_added", (snap) => {
			this.setState((preState) => {
				let data = snap.val();
				let createdAt = data.created_at;
				let recipient = data.recipients && data.recipients[user_id];
				if (recipient && recipient.status === 'unread') {
					gs.readMessage(activeKey, createdAt, user_id);
				}
				return { threads: [...preState.threads, snap.val()] }
			});
			this.scrollToBottom()
		});
	}

	componentDidUpdate() {
		this.scrollToBottom();
	}


	scrollToBottom = () => {
		animateScroll.scrollToBottom({ containerId: "messagingContainer" });
	};

	componentWillUnmount() {
		this.setState(this.initilizeState);
	}

	renderMessage = (idx, data, activeKey) => {

		const isMine = Number.isInteger(data.sender) ? (parseInt(gs.identity.user.user_id) === parseInt(data.sender)) : (parseInt(gs.identity.user.user_id) === parseInt(data.sender.id));

		const sender = data.recipients[parseInt(data.sender)];
		const friendlyTimestamp = moment(data.created_at).format('lll');
		return (<li key={idx} className={isMine === true ? ' mine' : ''}>
			<div className="title">
				<div className="name">{sender.name}</div>
				<div className="time">{friendlyTimestamp}</div>
			</div>
			{(data.is_attachment === true) ? (<Attachment activeKey={activeKey} createdAt={data.created_at} attachment={data.text} />) : (<div className="text" dangerouslySetInnerHTML={{ __html: (data && data.text) }}></div>)}
			
		</li>);
	}

	render() {
		const { threads, recipients, item, profile, activeKey } = this.state;

		//console.log(recipients);

		return (<div className="messages">
			<MessangerProfile profile={profile} item={item} />
			<div className="msg-list css-scroll scroll-window" id="messagingContainer">
				<ul>
					{threads.map((thread, idx) => this.renderMessage(idx, thread, activeKey))}
				</ul>
			</div>
			<MessageComposer activeKey={activeKey} profile={profile} item={item} />
		</div>);
	}
}

const processSelector = createSelector(
	state => state.process,
	process => process
);

const messageSelector = createSelector(
	state => state.message,
	message => message
);

const mapStateToProps = createSelector(
	processSelector,
	messageSelector,
	(process, message) => ({
		process,
		message
	})
);

export default connect(mapStateToProps)(Messenger);
